export default {
  loginRegister: 'Login | Register',
  login: 'Login',
  register: 'Register',
  loginWithPassword: 'Login with password',
  otpLogin: 'Login via one-time password',
  twoStepVerification: 'Two step verification',
  loginDescription_html: 'Hi!<br/>Please enter your mobile number',
  pleaseEnterYourPassword: 'Please enter your password',
  forgotPassword: 'Forgot password',
  password: 'Password',
  otpLoginTemplate_html:
    'Verification code sended to <b>{mobile}</b>.<br/>Please enter verification code',
  otpCountdownTemplate: '{minutes}:{seconds} remains to re-send code',
  sendOtpCode: 'Send verification code',
  resendOtpCode: 'Resend verification code',
  verificationCode: 'Verification code',
  firstName: 'First name',
  lastName: 'Last name',
  nationalId: 'National id',
  gender: 'Gender',
  fatherName: 'Father name',
  licenseType: 'License type',
  licenseNumber: 'License number',
  licenseIssueTime: 'License issue time',
  licenseExpireTime: 'License expire time',
  licenseFrontImage: 'License front image',
  licenseBackImage: 'License back image',
  healthCardBackImage: 'Health card back image',
  healthCardFrontImage: 'Health card front image',
  nationalCardBackImage: 'National card back image',
  nationalCardFrontImage: 'National card front image',
  smartCardBackImage: 'Smart card back image',
  smartCardFrontImage: 'Smart card front image',
  vehicleSmartCardBackImage: 'Vehicle Smart card back image',
  vehicleSmartCardFrontImage: 'Vehicle Smart card front image',
  vehicleCardFrontImage: 'Vehicle card front image',
  vehicleCardBackImage: 'Vehicle card back image',
  vehicleImages: 'Vehicle images',
  iWouldAlsoLikeToWorkAtVIPLevel: 'I would also like to work at the VIP level',
  ourColleaguesWillContactYouSoon: 'Our colleagues will contact you soon',
  image: 'Image',
  password2: 'Password again',
  next: 'Next',
  back: 'Back',
  registerHasBeenSuccessfully: 'Register has been successfully',
  logout: 'Logout',
  forgotPasswordDescription: 'To change password, enter your mobile number',
  resetPassword: 'Reset password',
  newPassword: 'New password',
  newPassword2: 'Repeat new password',
  email: 'Email',
  phone: 'Phone',
  editAccount: 'Edit account',
  changePassword: 'Change password',
  createPassword: 'Create password',
  currentPassword: 'Current password',
  carBrand: 'Car brand',
  carType: 'Car type',
  productionYear: 'Production year',
  carColor: 'Car color',
  carPlate: 'Car plate',
  available: 'Available',
  unavailable: 'Unavailable',
  faceImage: 'Face image',
  profilePictureUpdatedSuccessfylly: 'Profile picture updated successfylly',
  profilePictureRemovesSuccessfully: 'Profile picture removed successfylly',
  acceptTermsAndConditions: 'I accept the terms and conditions of Badpa.',
  conditions:
    "Driver Terms and Conditions:\n\n1. Having a valid driving license\n2. Minimum age of 23 years\n3. No criminal record\n4. Having a valid health card\n5. Having a suitable and well-maintained vehicle\n6. Full compliance with traffic rules and regulations\n7. Proper conduct with customers\n8. Maintaining work discipline\n9. Punctual attendance at workplace\n10. Taking care of customers' cargo and shipments"
}
